import { f as formatMoney } from './currency-BS0riN3f.js';

// import { detectOS } from './utils';

/**
 * @typedef {Object} Item
 * @property {number} id - The variant ID of the add-on.
 * @property {number} quantity - The quantity of the add-on.
 * @property {number} price - The price of the add-on in cents.
 * @property {number} compareAtPrice - The compare at price of the add-on in cents.
 */

/**
 * @class ProductAddOn
 * @extends HTMLElement
 * @description Handles the popular add on functionality.
 * @example <product-add-on class="block" data-product-id="{{ product.id }}" data-variant-id="{{ variant_id }}" data-compare-at-price="{{ variant_compare_price }}" data-price="{{ variant_price }}"></product-add-on>
 */
class ProductAddOn extends HTMLElement {
  input = this.querySelector('input[type="checkbox"]');
  controller = new AbortController();

  // typeIsPreselectedBefore = false;

  connectedCallback() {
    this.input?.addEventListener('change', () => this.handleChange(), {
      signal: this.controller.signal,
    });

    this.unsubscribeVariantChange = subscribe(`variant:changed:${this.dataset.productId}`, () => {
      console.log('product add on js variant changed');
      this.handleChange();
    });
  }

  disconnectedCallback() {
    this.controller.abort();
    this.unsubscribeVariantChange();
  }

  // updateBasedOnOS() {
  //   // Detect the operating system
  //   const { isIOS, isMacOS, isAndroid } = detectOS();

  //   const osTypes = Array.from(this.querySelectorAll('product-add-on-type[data-os]')).map(
  //     (type) => type.dataset.os
  //   );

  //   // If the operating system is detected and the type is included in the osTypes, click the label
  //   if (isIOS && osTypes.includes('ios'))
  //     this.querySelector(`product-add-on-type[data-os="ios"] label`).click();
  //   if (isMacOS && osTypes.includes('macos'))
  //     this.querySelector(`product-add-on-type[data-os="macos"] label`).click();
  //   if (isAndroid && osTypes.includes('android'))
  //     this.querySelector(`product-add-on-type[data-os="android"] label`).click();
  // }

  handleChange = () => {
    // Create item update object
    const item = {
      id: parseInt(this.dataset.variantId),
      quantity: 1,
      price: parseInt(this.dataset.price),
      compareAtPrice: parseInt(this.dataset.compareAtPrice),
    };

    // Based on the checkbox add or remove the popular add on
    this.input.checked ? this.addPopularAddOn(item) : this.removePopularAddOn(item);

    // Preselect the add on type based on your operating system
    // if (!this.typeIsPreselectedBefore) {
    //   this.updateBasedOnOS();
    //   this.typeIsPreselectedBefore = true;
    // }
  };

  /**
   * @method addPopularAddOn
   * @description Adds a popular add-on to the product.
   * @param {Item} item - The item to add.
   * @returns {void}
   */
  addPopularAddOn(item) {
    publish(`product-add-on:add:${this.dataset.productId}`, item);
    this.classList.add('expanded');
  }

  removePopularAddOn(item) {
    publish(`product-add-on:remove:${this.dataset.productId}`, item);
    this.classList.remove('expanded');
  }
}

customElements.define('product-add-on', ProductAddOn);

/**
 * @class ProductAddOnType
 * @extends HTMLElement
 * @description Changes the variant and price of the parent popular add on.
 */
class ProductAddOnType extends HTMLElement {
  popularAddOnParent = this.closest('product-add-on');
  controller = new AbortController();

  connectedCallback() {
    // The parent popular add on is required to be present
    if (!this.popularAddOnParent) return;
    this.addEventListener('change', (event) => this.handleChange(event), {
      signal: this.controller.signal,
    });
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  handleChange = (event) => {
    event.stopPropagation();

    // first remove the popular add on
    this.popularAddOnParent.removePopularAddOn({
      id: parseInt(this.popularAddOnParent.dataset.variantId),
      quantity: 1,
      price: parseInt(this.popularAddOnParent.dataset.price),
    });

    // Now set the new selected product variant and price on the parent popular add on for calculating the totals
    this.popularAddOnParent.setAttribute('data-variant-id', this.dataset.variantId);
    this.popularAddOnParent.setAttribute(
      'data-compare-at-price',
      this.dataset.compareAtPrice || this.dataset.price
    );
    this.popularAddOnParent.setAttribute('data-price', this.dataset.price);
    this.popularAddOnParent.classList.add('expanded');

    // Update the price of the parent popular add on
    const variantPrice = this.popularAddOnParent.querySelector('[data-current-price]');
    if (variantPrice) {
      this.popularAddOnParent.querySelector('[data-current-price]').textContent = formatMoney(
        parseInt(this.dataset.price),
        window.SHOP_MONEY_FORMAT
      );
    }

    // Update the description of the parent popular add on based on selected item
    const description = this.popularAddOnParent.querySelector(
      '[data-product-add-on="description"]'
    );
    const newDescriptionText = this.querySelector(
      '[data-product-add-on-type="description"]'
    ).textContent;
    if (description && newDescriptionText) {
      description.textContent = newDescriptionText;
    }

    // Set checked and dispatch change event to trigger the change handler
    const checkbox = this.popularAddOnParent.querySelector('input[type="checkbox"]');
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change'));
  };
}

customElements.define('product-add-on-type', ProductAddOnType);
